class ShareButton {
    constructor() {
        this.openDropdownBtn = document.querySelector(".share-button");
        this.openDropdownBtnMob = document.querySelector(".share-button-mobile");
        this.dropdown = document.querySelectorAll(".share-button__dropdown");
        this.copyUrlBtn = document.querySelectorAll("#copytUrl");
        this.sendEmailBtn = document.querySelectorAll("#sendEmailJs");
        this.twitterShare = document.querySelectorAll("#twitterShare");
        this.fbShare = document.querySelectorAll("#fbShare");
        this.msgShare = document.querySelectorAll("#shareMessenger");
        this.waShare = document.querySelectorAll("#shareWhatsapp")
        this.events();
    }

    events() {


        if (this.openDropdownBtn) {
            this.openDropdownBtn.addEventListener("click", (evt) => {
                evt.preventDefault();
                evt.target.tagName !== "a" ? evt.stopPropagation() : "";
                !this.openDropdownBtn.querySelector(".share-button__dropdown").classList.contains("shown") ?
                    this.openDropdownBtn.querySelector(".share-button__dropdown").classList.add("shown") :
                    "";
            });

            window.addEventListener("click", (evt) => {
                if (
                    evt.target !== this.openDropdownBtn &&
                    evt.target !== this.dropdown &&
                    !evt.target.classList.contains('share-button__dropdown-item')

                ) {
                    this.closeDropdown();
                }
            });
        }
        if (this.openDropdownBtnMob) {
            this.openDropdownBtnMob.addEventListener("click", (evt) => {
                if (!this.openDropdownBtnMob.classList.contains("open")) {
                    evt.preventDefault();
                    evt.target.tagName !== "a" ? evt.stopPropagation() : "";
                    !this.dropdown.forEach(el => {
                        if (!el.classList.contains("shown")) {
                            el.classList.add("shown")
                        }
                    })
                    this.openDropdownBtnMob.classList.toggle("open");
                } else {
                    this.closeDropdown()
                }
            });


            window.addEventListener("click", (evt) => {
                if (
                    evt.target !== this.openDropdownBtnMob &&
                    evt.target !== this.dropdown &&
                    !evt.target.classList.contains('share-button__dropdown-item')
                ) {
                    this.closeDropdown();
                }
            });
        }
        if (this.copyUrlBtn) {
            this.copyUrlBtn.forEach(el => {
                el.addEventListener("click", (evt) => {
                    this.copyUrlToClipboard();
                    window.alert("Skopiowano link");
                });
            })
        }

        if (this.sendEmailBtn) {
            this.sendEmailBtn.forEach(el => {
                el.addEventListener("click", (evt) => {;
                    this.sendEmail();
                });
            })
        }

        if (this.twitterShare) {
            this.twitterShare.forEach(el => {
                el.addEventListener("click", (e) => {
                    var url = window.location.href
                    if (url.includes("meteogramy")) {
                        window.open(`https://twitter.com/intent/tweet?button_hashtag=meteo&ref_src=twsrc%5Etfw&text=${window.location.protocol + '//' + window.location.host + window.location.pathname + encodeURIComponent('?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType)}`)
                    } else {
                        window.open(`https://twitter.com/intent/tweet?button_hashtag=meteo&ref_src=twsrc%5Etfw&text=${url}`)
                    }

                })
            })
        }
        if (this.msgShare) {
            this.msgShare.forEach(el => {
                el.addEventListener("click", (e) => {
                    var url = window.location.href
                    if (url.includes("meteogramy")) {
                        window.open(`http://www.facebook.com/dialog/send?app_id=623065112079926&link=${window.location.protocol + '//' + window.location.host + window.location.pathname + encodeURIComponent('?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType)}&redirect_uri=${window.location.protocol + '//' + window.location.host + window.location.pathname + encodeURIComponent('?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType)}`)
                    } else {
                        window.open(`http://www.facebook.com/dialog/send?app_id=623065112079926&link=${url}`)
                    }
                })
            })
        }
        if (this.fbShare) {
            this.fbShare.forEach(el => {
                el.addEventListener("click", (e) => {
                    var url = window.location.href
                    if (url.includes("meteogramy")) {
                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.protocol + '//' + window.location.host + window.location.pathname + encodeURIComponent('?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType)}`)
                    } else {
                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`)
                    }
                })
            })
        }
        if (this.waShare) {
            this.waShare.forEach(el => {
                el.addEventListener("click", () => {
                    var url = window.location.href
                    if (url.includes("meteogramy")) {
                        window.open(`https://wa.me/?text=${window.location.protocol + '//' + window.location.host + window.location.pathname + encodeURIComponent('?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType)}`)
                    } else {
                        window.open(`https://wa.me/?text=${url}`)
                    }
                })
            })
        }


    }


    closeDropdown() {
        this.dropdown.forEach(el => {
            el.classList.contains("shown") ?
                el.classList.remove("shown") :
                "";
        })

        this.openDropdownBtnMob.classList.contains("open") ?
            this.openDropdownBtnMob.classList.remove("open") :
            ""
    }

    copyUrlToClipboard() {
        const hiddenTxtField = document.createElement("input");
        let location = JSON.parse(localStorage.getItem("location"))

        document.body.appendChild(hiddenTxtField);
        let pathname = window.location.pathname
        if (pathname.includes('meteogramy')) {
            hiddenTxtField.value = window.location.protocol + '//' + window.location.host + window.location.pathname + '?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng');
        } else {
            hiddenTxtField.value = window.location.protocol + '//' + window.location.host + window.location.pathname;
        }
        hiddenTxtField.focus();
        hiddenTxtField.select();
        document.execCommand("copy");
        hiddenTxtField.remove();
    }

    sendEmail() {
        var url = window.location.href
        if (url.includes("meteogramy")) {
            console.log('mailto: ?subject=meteogram&body=' + window.location.protocol + '//' + window.location.host + window.location.pathname + '?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType)
            document.location.href =
                'mailto: ?subject=meteogram&body=' + window.location.protocol + '//' + window.location.host + window.location.pathname + encodeURIComponent('?lat=' + localStorage.getItem('lat') + '&lng=' + localStorage.getItem('lng') + '&model=' + window.forecastType);
        } else {
            console.log('mailto: ?subject=komentarz&body=')
            document.location.href =
                'mailto: ?subject=komentarz&body=' + url
        }

    }
}

export default ShareButton;